/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import {
  TGetActiveTypesByBboxModel,
  IGetActiveTypesByBboxRequest,
  IMappers,
  IGetActiveTypesByBboxResponse,
  IGetActiveTypesByBboxResponseError,
  TGetActiveTypesByBboxResponse,
} from './types';

const defaultConfig: TGetActiveTypesByBboxModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'infrastructure-caching',
  pathApi: '/v1/get-active-types-by-bbox/',
  hostType: 'api',
} as TGetActiveTypesByBboxModel;

function createGetActiveTypesByBboxModel(parameters: IGetActiveTypesByBboxRequest): TGetActiveTypesByBboxModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetActiveTypesByBboxOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetActiveTypesByBboxRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetActiveTypesByBbox<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetActiveTypesByBboxOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetActiveTypesByBboxResponse
> {
  const { response, statusCode } = await httpApi.fetch(createGetActiveTypesByBboxModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetActiveTypesByBboxResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetActiveTypesByBboxResponseError);
    }
  }

  return { response, statusCode } as TGetActiveTypesByBboxResponse;
}

export { defaultConfig, createGetActiveTypesByBboxModel, fetchGetActiveTypesByBbox };
